module.exports = __webpack_public_path__ + "img/icon_partc_to_partb.48aba47a.svg";